import {
  MPAOperationScope,
  MPAOperationType,
  MPARequestStatus,
} from '@repo/api-gw-sdk';

export const operationVerbs: Record<MPAOperationType, string> = {
  [MPAOperationType.MPA_OPERATION_TYPE_UNSPECIFIED]: 'perform',
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_ADD_RESTORE_ACCOUNT]:
    'connect',
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_DELETE_BACKUP_POLICY]:
    'delete',
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_UPDATE_BACKUP_POLICY]:
    'update',
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_RESTORE_RESOURCE]:
    'restore',
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_REMOVE_SNAPSHOT_HOLD]:
    'remove a snapshot hold',
};

export const noScopeAllCopy: Partial<Record<MPAOperationType, string>> = {
  [MPAOperationType.MPA_OPERATION_TYPE_MPA_OPERATION_ADD_RESTORE_ACCOUNT]:
    'All restore accounts',
};

interface ScopeCopy {
  allCopy: string;
  selectionCopy: string;
}

export const scopeCopy: Partial<Record<MPAOperationScope, ScopeCopy>> = {
  [MPAOperationScope.MPA_OPERATION_SCOPE_BACKUP_POLICY]: {
    allCopy: 'All current and future backup policies',
    selectionCopy: 'These backup policies:',
  },
  [MPAOperationScope.MPA_OPERATION_SCOPE_CLOUD_RESOURCE]: {
    allCopy: 'All current and future resources',
    selectionCopy: 'These resources:',
  },
};

type StatusTone =
  'pending' | 'success' | 'error' | 'neutral' | 'disabled' | 'apply';

interface StatusDescriptor {
  label: string;
  tone: StatusTone;
}

export const statusDescriptors: Record<MPARequestStatus, StatusDescriptor> = {
  [MPARequestStatus.MPA_REQUEST_STATUS_UNSPECIFIED]: {
    label: 'Unknown',
    tone: 'neutral',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_CREATED]: {
    label: 'Created',
    tone: 'neutral',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_PENDING_APPROVAL]: {
    label: 'Pending approval',
    tone: 'pending',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_APPROVED]: {
    label: 'Ready to apply',
    tone: 'apply',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_DENIED]: {
    label: 'Denied',
    tone: 'error',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_EXPIRED_PENDING_APPROVAL]: {
    label: 'Expired',
    tone: 'disabled',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_EXPIRED_APPROVED]: {
    label: 'Expired',
    tone: 'disabled',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_EXECUTED]: {
    label: 'Completed',
    tone: 'success',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_CANCELLED_PENDING_APPROVAL]: {
    label: 'Canceled',
    tone: 'disabled',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_CANCELLED_APPROVED]: {
    label: 'Canceled',
    tone: 'disabled',
  },
  [MPARequestStatus.MPA_REQUEST_STATUS_DISCARDED]: {
    label: 'Discarded',
    tone: 'disabled',
  },
};

export const toneColors: Record<StatusTone, { bg: string; fg: string }> = {
  pending: {
    bg: 'var(--mui-palette-warning-bgLight)',
    fg: 'var(--mui-palette-warning-main)',
  },
  success: {
    bg: 'var(--mui-palette-success-bgLight)',
    fg: 'var(--mui-palette-success-main)',
  },
  error: {
    bg: 'var(--mui-palette-error-opacity)',
    fg: 'var(--mui-palette-error-main)',
  },
  neutral: {
    bg: 'var(--mui-palette-background-default)',
    fg: 'var(--mui-palette-text-secondary)',
  },
  disabled: {
    bg: 'var(--mui-palette-background-default)',
    fg: 'var(--mui-palette-text-disabled)',
  },
  apply: {
    bg: 'var(--mui-palette-custom-ORANGE-OPACITY-01)',
    fg: 'var(--mui-palette-custom-ORANGE-01)',
  },
};
